import {
  UnitSelectionWidget,
  UserSelectionWidget,
} from "components/FormWidget";

const uiSchema = () => ({
  unit_ids: {
    "ui:widget": UnitSelectionWidget,
  },
  doctor_ids: {
    "ui:widget": UserSelectionWidget,
    "ui:options": {
      initFilter: {
        type_ids: ["2", "3"],
      },
    },
  },
});

export default uiSchema;
